import { render } from "./UpcomingEventsCalendarCardInfo.vue?vue&type=template&id=588445ad"
import script from "./UpcomingEventsCalendarCardInfo.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsCalendarCardInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__